import { useLoaderData } from 'react-router';
import { Suspense } from 'react';
import { Await } from 'react-router';
import PropTypes from 'prop-types';
import PanelHeader from '../core/PanelHeader';
import NodeFormContent from './NodeFormContent';

const LoadingFallback = ({ actions }) => (
  <div className="h-full flex flex-col">
    <PanelHeader title="Please wait..." isEditable={false}>
      {actions}
    </PanelHeader>
    <div className="flex-1 flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
    </div>
  </div>
);

LoadingFallback.propTypes = {
  actions: PropTypes.node.isRequired,
};

const NodeFormWrapper = ({ nodeId, actions, locked }) => {
  const { results } = useLoaderData();

  return (
    <Suspense fallback={<LoadingFallback actions={actions} />}>
      <Await resolve={results}>{() => <NodeFormContent nodeId={nodeId} actions={actions} locked={locked} />}</Await>
    </Suspense>
  );
};

NodeFormWrapper.propTypes = {
  nodeId: PropTypes.string.isRequired,
  actions: PropTypes.node.isRequired,
  locked: PropTypes.bool.isRequired,
};

export default NodeFormWrapper;
